import { Euler, Mesh, Vector3 } from "three";
import { OrientationData, OriginalColors } from "~/src/utils/shape";

export enum Action {
    Add = "add",
    Edit = "edit",
    Delete = "delete",
    HandleInvalidJoints = "handleInvalidJoints",
    DragAndDrop = "drag",
    CopyPaste = "copyPaste",
    Duplicate = "duplicate",
}

export interface UndoRedoAction {
    actionType: Action;
    selectedOption?: string;
    mesh?: Mesh;
    meshes?: Mesh[];
    meshStates?: MeshState[]; // For edit actions
}

export interface MeshState {
    mesh: Mesh;
    previousOrientation?: OrientationData;
    previousRotation?: Euler;
    previousPosition?: Vector3;
    previousOriginalColors?: OriginalColors;
    wasInvalid?: boolean;
}
